export default __webpack_public_path__ + "static/media/08.286a512f.jpg";